export default "__VITE_ASSET__1520b880__"